import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import { EMPTY_ARR } from 'Services/constants/empty';
import ModalBase from './component';

export default connect((state) => ({
  modals: get(state, ['Modals'], EMPTY_ARR),
}), (dispatch) => ({
  modalClose: (modalId) => dispatch(actions.modalClose(modalId)),
}))(ModalBase);
